let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iiqDR")).then(() => parcelRequire('if0JX'));